import React, { useState } from 'react';
import { submitSurveyResponse } from '../lib/surveyHelpers';
import './NotificationBell.css';

const SurveyModal = ({ question, userId, onClose, onSubmitted }) => {
  const [selected, setSelected] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [thankYou, setThankYou] = useState(false);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handleSubmit = async () => {
    if (!selected) return;
    setSubmitting(true);
    setError(null);

    const { error: submitError } = await submitSurveyResponse(
      question.id,
      userId,
      selected
    );

    setSubmitting(false);

    if (submitError) {
      setError(submitError.message || 'Failed to submit. Please try again.');
      return;
    }

    setThankYou(true);
    setTimeout(() => {
      onSubmitted();
    }, 1500);
  };

  return (
    <div className="survey-modal-overlay" onClick={handleOverlayClick}>
      <div className="survey-modal">
        <button className="survey-modal-close" onClick={onClose}>×</button>

        {thankYou ? (
          <div className="survey-thank-you">
            <div className="survey-thank-you-icon">✓</div>
            <div className="survey-thank-you-text">Thanks for your response!</div>
          </div>
        ) : (
          <>
            <div className="survey-modal-title">This Week's Survey</div>
            <div className="survey-modal-question">{question.question_text}</div>

            <div className="survey-modal-options">
              {question.options.map((opt) => (
                <button
                  key={opt.id}
                  className={`survey-option-btn ${selected === opt.id ? 'selected' : ''}`}
                  onClick={() => setSelected(opt.id)}
                >
                  {opt.label}
                </button>
              ))}
            </div>

            {error && <div className="survey-modal-error">{error}</div>}

            <button
              className="survey-submit-btn"
              onClick={handleSubmit}
              disabled={!selected || submitting}
            >
              {submitting ? 'Submitting...' : 'Submit'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SurveyModal;
